import { Platform } from 'react-native';

// Shadows from the HTML tokens (--shadow-sm / --shadow / --shadow-lg). Web uses
// boxShadow; native approximates with shadow* + elevation.
export const Shadows = {
  sm: Platform.select({
    web: { boxShadow: '0 1px 0 rgba(0,0,0,0.04)' },
    default: {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 1 },
      shadowOpacity: 0.04,
      shadowRadius: 0,
      elevation: 1,
    },
  }),
  base: Platform.select({
    web: { boxShadow: '0 1px 2px rgba(0,0,0,0.06), 0 6px 16px -8px rgba(0,0,0,0.14)' },
    default: {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 3 },
      shadowOpacity: 0.1,
      shadowRadius: 8,
      elevation: 3,
    },
  }),
  lg: Platform.select({
    web: { boxShadow: '0 8px 30px -10px rgba(0,0,0,0.28)' },
    default: {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 8 },
      shadowOpacity: 0.28,
      shadowRadius: 20,
      elevation: 12,
    },
  }),
};
